define(function (require) {
  'use strict';

  var _ = require('underscore');
  var Marionette = require('marionette');
  var TemplatesModel = require('models/messageTemplate');
  var BodyTPL = require('text!modals/email_edit/body.tpl').default;
  var Config = require('config/application');

  return Marionette.ItemView.extend({
    template: BodyTPL,
    className: 'b-popover__email_edit-body',

    ui: {
      domain: '.js-email-domain',
      username: '.js-email-user',
      textarea: '.b-popover__email_edit-text',
      templateSelect: '.js-email-template',
      addTemplateBtn: '.js-add-tpl'
    },

    events: {
      'change @ui.domain': 'changeDomain',
      'keyup @ui.username': 'changeUsername',
      'change @ui.templateSelect': 'onSelectTemplate',
      'click @ui.addTemplateBtn': 'onClickAddTemplate'
    },

    initialize: function (options) {
      options = options || {};

      this.emails = options.emails || [];

      var list = [];
      var newID = 0;
      /** add domains to list */
      options.domains.forEach(function (el) {
        newID = Math.max(newID, el.id);
        list.push({
          id: el.id,
          type: 'txt',
          domain: el.domain,
          username: '',
          editable: true,
        });
      });

      /**add default Domain */
      list.push({
        id: ++newID,
        type: 'txt',
        domain: 'lpt-land.ru',
        username: 'noreply',
        editable: true,
      });

      this.emailList = list;
      // console.log(this.emailList);

      this.templates = options.templates;

      this.listenTo(this.model, 'invalid', this.onInvalid);
      this.listenTo(this.model, 'change:template_id', this.onChangeTemplateId);
      this.listenTo(this.model, 'change:subject change:text', this.onChangeText);
    },

    changeDomain: function () {
      var id = this.ui.domain.val();
      var domain = this.emailList.find(function (el) { return (el.id == id);});

      this.ui.username.val(domain.username);

      if (!domain.editable) {
        this.ui.username.attr('readonly', 'readonly');
      }
      else {
        this.ui.username.removeAttr('readonly');
      }

      this.model.set('from',
        (domain.username) ? domain.username : 'noreply'
          + '@' + domain.domain
      );
    },

    changeUsername: function () {
      var username = (this.ui.username.val() || '').toLowerCase().replace(new RegExp('[^a-z0-9.]', 'g'), '');

      var domain_id = this.ui.domain.val();
      var domain = this.emailList.find(function (el) { return (el.id == domain_id);});

      this.ui.username.val(username);
      username = username || 'noreply';
      this.model.set('from', username + '@' + domain.domain);
    },

    onSelectTemplate: function () {
      var templateId = this.ui.templateSelect.val();
      var template = templateId && this.templates.get(templateId);

      if (template) {
        this.model.set({
          subject: template.get('template_subject'),
          text: template.get('template_text'),
          template_id: templateId
        });
      }
    },

    createSelect: function () {
      var that = this;
      var templateId = this.model.get('template_id');

      this.ui.templateSelect.select2({
          dropdownParent: that.$el,
          allowClear: true,
          placeholder: {
              id: '',
              text: "Название шаблона",
              selected: 'selected'
          },
          // data: [{ id: '', text: '', selected: 'selected', search: '', hidden: true }].concat(this.templates.toJSON()),
          escapeMarkup: function (markup) {
              return markup;
          },
          language: {
              noResults: function () {
                  var query = that.$('.select2-search__field').val();
                  return '<a href="javascript:void(0);" class="js-add-tpl">' + query + ' (создать новый шаблон)</a>';
              }
          },
          templateResult: function(state) {
              if (!state.id && !state.value){
                  return state.text;
              }
              var html = '<span>';
                html += state.text;
                html += '<i style="float:right" class="js-delete-template fa fa-times" data-id="' + state.id + '"></i>';
                html += '</span>';

              var $state = $(html);
              return $state;
          }
      });
      this.ui.templateSelect.off('select2:selecting');
      this.ui.templateSelect.on('select2:selecting', function(event) {
            var args = event.params.args;
            var id;
            if ($(args.originalEvent.target).hasClass('js-delete-template')) {
                var cid = $(args.originalEvent.target).data('id');
                that.deleteTemplate(cid);
                return false;
            }
      });
      if (templateId) {
        this.ui.templateSelect.val(templateId).trigger('change');
      }
    },

    deleteTemplate: function(cid)
    {
        var that = this;
        var template = this.templates.get(cid);
        var templateId = template.get('id');
        if(templateId){
            Backbone.ajax({
                url: Config.host + '/rest/templates/' + templateId,
                dataType: 'JSON',
                type: 'DELETE',
                success: function (response) {
                    app.message.success('Шаблон удален');
                    that.templates.remove(cid);
                    that.render();
                },
                error: function (xhr) {
                    app.message.success('Ошибка удаления шаблона');
                }
            });
        }else{
            that.templates.remove(cid);
            that.render();
        }
    },

    onClickAddTemplate: function () {
      var name = this.$('.select2-search__field').val();
      var model = new TemplatesModel({
        template_name: name,
        template_subject: this.model.get('subject'),
        template_text: this.model.get('text'),
        type: 1,
      });
      //
      //if (!this.model.get('subject') || !this.model.get('text')) {
      //    app.message.error('Заполните тему и текст сообщения');
      //    return;
      //}

      //model
      //    .save()
      //    .then(function() {
      this.templates.add(model);
      this.model.set('template_id', model.cid);
      this.render();
      //app.message.success('Шаблон сохранен');
      //}.bind(this))
      //.fail(function(xhr) {
      //    var message = xhr.responseJSON && xhr.responseJSON.message || 'Не удалось сохранить шаблон';
      //    app.message.error(message);
      //})
    },

    onRender: function () {
      app.Rivets.bind(this.el, { model: this.model });
      this.createSelect();
    },

    serializeData: function () {
      var templates = [];

      this.templates.each(function (template) {
        var obj = template.toJSON();

        obj.cid = template.cid;
        templates.push(obj);
      });

      /** Init state */
      var username = (this.emailList.lenght) ? this.emailList[0].username : '';
      var usernameReadonly = (this.emailList.lenght) ? !this.emailList[0].editable : false;

      return {
        username: username,
        usernameReadonly: usernameReadonly,
        modal: this.model.toJSON(),
        emails: this.emailList,
        templates: templates,
      }
    },

    onChangeText: function () {
      if (this.model.get('template_id')) {
        this.trigger('toggleAddTemplateBtn', true);
      }
    },

    onChangeTemplateId: function (model, value) {
      if (value) {
        this.trigger('toggleAddTemplateBtn', this.templates.get(value).isNew());
      }
    },

    onInvalid: function (model, errors) {
      var that = this;
      var message = '';
      this.$('.js-subject').removeClass('error-control');
      this.$('.js-text').removeClass('error-control');
      _.each(errors, function (error, i) {
        if (i > 0) {
          message += '<br/>';
        }
        message += error.message;
        that.$('.js-' + error.field).addClass('error-control');
      });
      app.message.error(message);
    }
  });
});
